import { render, staticRenderFns } from "./goodsInfo.vue?vue&type=template&id=4913e33d&"
import script from "./goodsInfo.vue?vue&type=script&lang=js&"
export * from "./goodsInfo.vue?vue&type=script&lang=js&"
import style0 from "./goodsInfo.vue?vue&type=style&index=0&id=4913e33d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports